import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { CreditAssignmentTable } from '../components/credit-assignment/CreditAssignmentTable';
import { SearchIcon, FilterIcon, DownloadIcon, PlusIcon } from 'lucide-react';
export function CessioneCredito() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterActive, setFilterActive] = useState(false);
  const [onlyEligible, setOnlyEligible] = useState(false);
  const toggleFilter = () => {
    setFilterActive(!filterActive);
  };
  const toggleEligibleFilter = () => {
    setOnlyEligible(!onlyEligible);
  };
  return <div className="space-y-6 pb-16" data-id="element-1992">
      <div data-id="element-1993">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1994">
          Cessione del Credito
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1995">
          Gestisci e monitora i crediti cedibili e le relative procedure di
          cessione.
        </p>
      </div>
      <Card data-id="element-1996">
        <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-between mb-4" data-id="element-1997">
          <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-4" data-id="element-1998">
            <div className="relative flex-1 max-w-md" data-id="element-1999">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2000">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2001" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Cerca per cliente, fattura..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2002" />
            </div>
            {filterActive && <div className="flex items-center space-x-4" data-id="element-2003">
                <div className="flex items-center" data-id="element-2004">
                  <input id="only-eligible" name="only-eligible" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={onlyEligible} onChange={toggleEligibleFilter} data-id="element-2005" />
                  <label htmlFor="only-eligible" className="ml-2 block text-sm text-gray-900" data-id="element-2006">
                    Solo fatture eleggibili
                  </label>
                </div>
              </div>}
          </div>
          <div className="flex space-x-2" data-id="element-2007">
            <button className={`inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md ${filterActive ? 'bg-blue-50 text-blue-700' : 'bg-white text-gray-700 hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} onClick={toggleFilter} data-id="element-2008">
              <FilterIcon className="h-4 w-4 mr-2" data-id="element-2009" />
              Filtri
            </button>
            <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-2010">
              <DownloadIcon className="h-4 w-4 mr-2" data-id="element-2011" />
              Esporta
            </button>
          </div>
        </div>
        <CreditAssignmentTable searchTerm={searchTerm} onlyEligible={onlyEligible} data-id="element-2012" />
      </Card>
    </div>;
}